
/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

require('./bootstrap');

import Dropzone from "dropzone";
require('@fancyapps/fancybox');
require('jquery-validation');
require('mailcheck');

window.formatRegistration = function(registration) {

    registration = registration.toUpperCase();
    registration = registration.replace(/\s+/g, '');

    var formatted = false, type = false;

    if (registration.match(/^[A-Z]{2}(5[1-9]|0[2-9]|6[0-9]|1[0-9]|2[0-9]|7[0-9])[A-Z]{3}$/))
    {
        formatted = registration.slice(0, 4) + ' ' + registration.slice(4, registration.length);
        type = 1;
    }
    else if (registration.match(/^[A-Z][0-9]{1,3}[A-Z]{3}$/))
    {
        formatted = registration.replace(/(\d(?=\D*$))/, "$1 ");

        type = 2;
    }
    else if (registration.match(/^[A-Z]{3}[0-9]{1,3}[A-Z]$/))
    {
        formatted = registration.replace(/(^\D*)(\d)/, "$1 $2");

        type = 3;
    }
    else if (registration.match(/^[A-HJ-Y]{1,3}[0-9]{1,4}$/) || registration.match(/^[0-9]{1,4}[A-HJ-Y]{1,3}$/) || registration.match(/^[A-HJ-Y][0-9]{1,4}[A-HJ-Y]$/) )
    {
        formatted = registration.replace(/(\d(?=\D*$))/, "$1 ");

        if( formatted.slice(-1) == " " )
        {
            formatted = registration.replace(/(^\D*)(\d)/, "$1 $2");
        }

        type = 4;
    }
    else if (registration.match(/^[A-Z]{0,2}[IZ][A-Z]{0,2}[0-9]{1,4}$/) || registration.match(/^[0-9]{1,4}[A-Z]{0,2}[IZ][A-Z]{0,2}$/) )
    {
        formatted = registration.replace(/(\d(?=\D*$))/, "$1 ");

        if (formatted.slice(-1) == " ")
        {
            formatted = registration.replace(/(^\D*)(\d)/, "$1 $2");
        }

        type = 5;
    }

    return {
        formatted: formatted,
        type: type
    };
}

$.validator.addMethod('mobile', function (value) {
    return /^07[0-9]{9}$/.test(value);
}, 'Please enter a valid UK mobile with no spaces or country prefix, e.g. 07540123123.');

// Matches UK postcode. Does not match to UK Channel Islands that have their own postcodes (non standard UK)
$.validator.addMethod( "postcodeUK", function( value, element ) {
    return this.optional( element ) || /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test( value );
}, 'Please enter a valid UK postcode.');

Number.prototype.formatMoney = function(c, d, t)
{
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function debounce(fn, delay) {
    var timer = null;

    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);

        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}

window.valid = function(registration)
{
    return formatRegistration(registration).type > 0;
}

$(function() {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('.menu-open').click(function(e) {
        e.preventDefault();

        $('.mobile-menu').addClass('visible');
    });

    $('.menu-close').click(function(e) {
        e.preventDefault();

        $('.mobile-menu').removeClass('visible');
    });

    if( $('.card-element').length )
    {
        var elements = stripe.elements({
            fonts: [
                {
                    cssSrc: 'https://fonts.googleapis.com/css?family=Poppins:400'
                }
            ]
        });

        var style = {
            base: {
                color: '#000',
                fontFamily: 'Poppins',
                fontSize: '14px',
                '::placeholder': {
                    color: '#999'
                }
            },
            invalid: {
                color: '#000000',
                iconColor: '#fa755a'
            }
        };

        var card = elements.create('card', {hidePostalCode: true, style: style});
        card.mount('.card-element');

        card.on('change', ({error}) => {
            if (error) {
                $('.card-errors').text(error.message);
            } else {
                $('.card-errors').html('&nbsp;');
            }
        });

        $(document).on('change', '.cardholder-name', function(e) {
            var name = $(this).val();

            if (name != "") {
                $('.card-errors').html('&nbsp;');
                $('.cardholder-name').removeClass('StripeElement--invalid');
            }
        });

        $(document).on('submit', '.payment-form', function(e) {
            e.preventDefault();

            var $form = $(this);

            $form.find('.btn-success').prop('disabled', true);
            var name = $form.find('.cardholder-name').val();

            if (name == "") {
                $('.cardholder-name').addClass('StripeElement--invalid');
                $('.card-errors').text('Please enter the cardholder name.');
                $form.find('.btn-success').prop('disabled', false);
                return false;
            } else {
                $('.card-errors').html('&nbsp;');
                $('.cardholder-name').removeClass('StripeElement--invalid');
            }

            stripe.createPaymentMethod({
                type: 'card',
                card: card,
                billing_details: {
                    name: name,
                }
            }).then(function(result) {
                if (result.error) {
                    $('.card-errors').text(result.error.message);
                    $form.find('.btn-success').prop('disabled', false);
                } else {
                    var input = $('<input/>')
                        .attr('type', 'hidden')
                        .attr('name', 'paymentMethodId')
                        .attr('value', result.paymentMethod.id);

                    $form.append(input);
                    $form.get(0).submit();
                }
            });
        });
    }

    $(document).on('change', '.not-required', function(e) {

        var disabled = $(this).prop('checked');
        var target = $(this).data('target');

        // Disable the select box
        $('.' + target + '-type').prop('disabled', disabled);
        $('.' + target + '-type').parent().toggleClass('disabled', disabled);

        // Show the unselected message on the preview
        $('.' + target + '-plate').toggleClass('disabled', disabled);

        if(target == "rear") {
            if (disabled) {
                $('.additional-rear-wrapper').hide();
                $('.additional-rear').prop('checked', false);
            } else {
                $('.additional-rear-wrapper').show();
            }
        }

        updatePricing();
    });

    $('.front-type').change(function(e) {
        plateConfig.front = $(this).find('option:selected').data('key');

        updatePreview();
        updatePricing();
    });

    $('.rear-type').change(function(e) {
        plateConfig.rear = $(this).find('option:selected').data('key');

        updatePreview();
        updatePricing();
    });

    $('.additional-rear').change(function(e) {
        updatePricing();
    });

    function updatePreview()
    {
        updateType('front');
        updateType('rear');
    }

    function updateType(type)
    {
        var temp = plateConfig;
        temp.type = type;

        var url = '/image/preview?' + new URLSearchParams(temp).toString();

        var $image = $('<img />').attr('src', url);
        $('.' + type + '-plate img').attr('src', url);
    }

    $('.plate-badge').change(function(e) {
        plateConfig.badge = $(this).data('key');

        updatePreview();
        updatePricing();
    });

    $('.plate-border').change(function(e) {
        plateConfig.border = $(this).data('key');

        updatePreview();
        updatePricing();
    });

    $('.plate-font').change(function(e) {
        plateConfig.font = $(this).data('key');

        updatePreview();
        updatePricing();
    });

    $('.plate-ev').change(function(e) {
        plateConfig.ev = $(this).data('key');

        updatePreview();
    });

    $('.plate-fixing-kit').change(function(e) {
        updatePricing();
    });

    function updatePricing()
    {
        var count = 0;
        var base = 0;
        var options = 0;

        if( $('.front-type:enabled').length )
        {
            base += $('.front-type option:selected').data('price');
            count++;
        }

        if( $('.rear-type:enabled').length )
        {
            base += $('.rear-type option:selected').data('price');
            count++;
        }

        if( $('.additional-rear:checked').length ) {
            base += $('.rear-type option:selected').data('price');
            count++;
        }
        
        base += $('.plate-fixing-kit:checked').data('price');

        // Update the option pricing
        $('.plate-badge, .plate-border, .plate-font').each(function(key, opt) {
            var price = $(opt).data('price');
            var actual = count * price;

            $(opt).parent().find('.price').html( '&pound;' + ( actual / 100 ).formatMoney(2) );

            if( $(opt).prop('disabled') == false && $(opt).prop('checked') == true )
            {
                options += ( $(opt).data('price') * count )
            }
        });

        // Get the total (base + options)
        var total = base + options;

        $('.total-price span').html( '&pound;' + ( total / 100 ).formatMoney(2) );
        $('.was-price').html( '&pound;' + ( (total+400) / 100 ).formatMoney(2) );
    }

    $('.builder-registration').keyup(debounce(function() {
        var registration = $(this).val();

        if (valid(registration) || registration == "") {
            plateConfig.registration = registration;

            updatePreview();

            $('.invalid-registration').removeClass('visible');
        } else {
            $('.invalid-registration').addClass('visible');
        }
    }, 500));

    $('.btn-process-form').click(function(e) {
        e.preventDefault();

        var error = false;

        var data = {
            "product_id": 1,
            "meta": {
                "registration": ""
            },
            "children": []
        };

        data.meta.registration = $('.builder-registration').val();
        data.meta.foobar = 'bazboo';

        var front = $('.front-type:enabled').val();
        var rear = $('.rear-type:enabled').val();

        if( ! front && ! rear )
        {
            error = 'Please select atleast one plate (front/rear) to proceed.';
        }

        if( formatRegistration(data.meta.registration).formatted == false )
        {
            error = 'Please enter a valid registration.';
        }

        if( error )
        {
            alert(error);
            return false;
        }

        if( front )
        {
            data.children.push({
                "product_id": front,
                "meta": {
                    "plate": "F"
                }
            });
        }

        if( rear )
        {
            data.children.push({
                "product_id": rear,
                "meta": {
                    "plate": "R"
                }
            });
        }

        // Acrylic
        data.children.push({
            "product_id": $('.data-material').val()
        })

        $('.plate-border, .plate-badge, .plate-font').each(function(key, el) {

            if( $(el).prop('disabled') == false && $(el).prop('checked') )
            {
                data.children.push({
                    "product_id": $(el).val()
                });
            }
        });

        // Check if EV
        data.children.push({
            "product_id": $('.plate-ev:checked').val()
        });
        
        data.fixing_kit = $('.plate-fixing-kit:checked').val();

        var additional = $('.additional-rear').prop('checked');

        $.post('/cart/add', data, function(response) {
            openCart(response);
            resetState();
        });
    });

    $(document).on('click', '.cart-icon', function (e) {
        e.preventDefault()

        $.get('/cart', function(response) {
            openCart(response);
        });
    });

    $(document).on('click', '.slideout-cart--close', function (e) {
        e.preventDefault()

        closeCart();
    });

    $(document).on('click', '.slideout-cart--overlay', function (e) {
        closeCart();
    });

    $(document).on('submit', '.slideout-cart--remove-form', function (e) {
        e.preventDefault();

        $.post($(this).attr('action'), $(this).serialize(), function (response) {
            openCart(response);
        });
    })

    function openCart(html) {
        $('.slideout-cart--overlay').addClass('open');
        $('.slideout-cart--window').html(html);
        $('.slideout-cart--window').addClass('open');
        $('body').addClass('fix');
    }

    function closeCart()
    {
        $('.slideout-cart--overlay').removeClass('open');
        $('.slideout-cart--window').removeClass('open');
        $('body').removeClass('fix');
    }

    const defaultFrontTypeId = $('.front-type option:selected').val();
    const defaultRearTypeId = $('.rear-type option:selected').val();
    const defaultFontId = $('.plate-font:checked').val();
    const defaultBorderId = $('.plate-border:checked').val();
    const defaultBadgeId = $('.plate-badge:checked').val();
    const defaultEvId = $('.plate-ev:checked').val();
    const defaultFixingKitId = $('.plate-fixing-kit:checked').val();

    window.resetState = function ()
    {
        $('.builder-registration').val('');
        $('.invalid-registration').removeClass('visible');
        plateConfig.registration = '';

        $('.front-type').val(defaultFrontTypeId)
        $('.front-type').prop('disabled', false);
        $('.front-type').parent().removeClass('disabled');
        $('.front-plate').removeClass('disabled');
        $('[data-target="front"]').prop('checked', false);
        plateConfig.front = $('.front-type').find('option:selected').data('key');

        $('.rear-type').val(defaultRearTypeId);
        $('.rear-type').prop('disabled', false);
        $('.rear-type').parent().removeClass('disabled');
        $('.rear-plate').removeClass('disabled');
        $('[data-target="rear"]').prop('checked', false);
        plateConfig.rear = $('.rear-type').find('option:selected').data('key');

        $('.plate-font[value="' + defaultFontId + '"]').prop('checked', true);
        plateConfig.font = $('.plate-font:checked').data('key');

        $('.plate-border[value="' + defaultBorderId + '"]').prop('checked', true)
        plateConfig.border = $('.plate-border:checked').data('key');

        $('.plate-badge[value="' + defaultBadgeId + '"]').prop('checked', true);
        plateConfig.badge = $('.plate-badge:checked').data('key');

        $('.plate-ev[value="' + defaultEvId + '"]').prop('checked', true);
        plateConfig.ev = $('.plate-ev:checked').data('key');

        $('.plate-fixing-kit[value="' + defaultFixingKitId + '"]').prop('checked', true);

        updatePreview();
        updatePricing();
    }


    $('.ajax-add').submit(function(e) {
        e.preventDefault();
        var $form = $(this);

        $.post( $form.attr('action'), $form.serialize(), function(response) {
            openCart(response);
        });
    });

    //-----------------------------------
    // Checkout form
    //-----------------------------------
    var $checkout = $('.checkout-form');

    function checkoutSummary()
    {
        $.post('checkout/summary', $('.checkout-form').serialize(), function( response ) {
            $('.checkout-summary').html( response );
        });
    }

    $checkout.on('change', 'input', function(e) {
        checkoutSummary();
    });

    if( $checkout.length ) {
        checkoutSummary();
    }

    $checkout.validate({
        errorElement: 'small',
        rules: {
            'meta[mobile]': {
                mobile: true
            },
            'address[postcode]': {
                postcodeUK: true
            },
            'meta[email_confirmation]': {
                equalTo: '[name="meta[email]"]'
            }
        },
        messages: {
            'meta[email_confirmation]': {
                equalTo: 'Please ensure both emails match.',
            }
        },
        ignore: [],
        errorPlacement: function(error, element) {
            error.appendTo($(element).closest('.form-group'));
        },
        invalidHandler: function(form) {
            $('.address-fields').removeClass('hidden');
        },
        submitHandler: function (form) {
            stripeHandler(form);
        }
    });

    // var $email = $('input[id="meta[email]"]');
    // var $hint = $(".email-hint");

    // $email.on('blur',function() {
    //     $hint.css('display', 'none').empty();

    //     $(this).mailcheck({
    //         suggested: function(element, suggestion) {
    //             if (!$hint.html()) {
    //                 var suggestion = "Did you mean <span class='suggestion'>" +
    //                 "<span class='address'>" + suggestion.address + "</span>"
    //                 + "@<a href='#' class='domain'>" + suggestion.domain +
    //                 "</a></span>?";

    //                 $hint.html(suggestion).fadeIn(150);
    //             } else {
    //                 $(".address").html(suggestion.address);
    //                 $(".domain").html(suggestion.domain);
    //             }
    //         }
    //     });
    // });

    // $hint.on('click', '.domain', function(e) {
    //     e.preventDefault();

    //     $email.val($(".suggestion").text());

    //     $hint.fadeOut(200, function() {
    //         $(this).empty();
    //     });
    // });

    //-----------------------------------
    // Contact form
    //-----------------------------------
    $('.contact-form').validate({
        ignore: ".ignore",
        errorElement: 'small',
        rules: {
            'mobile': {
                mobile: true
            },
            'captcha': {
                required: function() {
                    return grecaptcha.getResponse() == '';
                }
            }
        }
    });

    //-----------------------------------
    // Document upload
    //-----------------------------------
    window.dropzones = [];

    var tpl = `<div class="dz-preview dz-file-preview">
        <div class="dz-details">
            <span class="dz-icon"></span>
            <span data-dz-name></span>
        </div>

        <div class="dz-success-message">
            <!-- <img src="/images/icon-success.svg" class="dz-icon-success"> -->
        </div>

        <div class="dz-error-message">
            <!-- <img src="/images/icon-success.svg" class="dz-icon-success"> -->
            <span data-dz-errormessage></span>
        </div>
    </div>`;

    window.progress = [];
    window.complete = 0;

    $('.file-upload').each(function(key, element) {

        progress[key] = 0;

        var key = $(element).data('key');
        var id = $(element).data('id');

        dropzones.push(new Dropzone( $(element).get(0), { // Make the whole body a dropzone
            url: "/document/upload",
            autoProcessQueue: false,
            previewsContainer: $(element).find('.previews').get(0),
            clickable: $(element).find('.btn').get(0),
            previewTemplate: tpl,
            createImageThumbnails: false,
            maxFilesize: 10,
            acceptedFiles: 'image/*,application/pdf',
            timeout: 0,
            params: {
                '_token': $('meta[name=csrf-token]').attr('content'),
                'key': key,
                'id': id
            },
            init: function() {
                this.on('error', function(file, response) {
                    $(file.previewElement).find('.dz-error-message span').text('There was an error uploading your files. This can happen when using an unstable internet connection. Please refresh the page and try again or email your documentation to contact@ukregplates.co.uk');
                });

                this.on('processing', function(uploadProgress) {
                    this.options.autoProcessQueue = true;
                });

                this.on('addedfile', function(file) {
                    updateFiles();
                });

                this.on('removedfile', function(file) {
                    updateFiles();
                });

                this.on('success', function(file) {
                    window.complete++;
                });
            }
        }));

    });

    function updateFiles()
    {
        setTimeout(function() {

            var count = 0;

            $(dropzones).each(function(key, dropzone) {
                count += dropzone.files.filter(obj => {
                    return obj.status === 'queued'
                }).length;
            });

            $('.upload').toggleClass('visible', count > 0);
        }, 0)

    }

    var timer;

    $('.process-upload').click(function(e) {

        $(this).prop('disabled', true);

        $(dropzones).each(function(key, dropzone) {
            dropzone.processQueue();
        });


        timer = window.setInterval(function() {

            var totalAcceptedFiles = 0;
            var totalUploadProgress = 0;

            $(dropzones).each(function(key, dropzone) {

                if( dropzone.getActiveFiles().length == 0 )
                {
                    totalUploadProgress = 100;
                }
                else
                {
                    var totalBytes = 0;
                    var totalBytesSent = 0;

                    $(dropzone.getAcceptedFiles()).each(function(key, file) {
                        totalBytesSent += file.upload.bytesSent;
                        totalBytes += file.upload.total;
                    });

                    totalUploadProgress = 100 * totalBytesSent / totalBytes;
                }

                totalAcceptedFiles += dropzone.getAcceptedFiles().length;
                progress[key] = totalUploadProgress;
            });

            var avg = Math.round(progress.reduce((a, b) => a + b, 0) / progress.length);

            $('.progress-bar .bar').css('width', avg + '%');
            $('.total-progress').text(avg + '%');


            if( window.complete == totalAcceptedFiles )
            {
                clearInterval(timer);

                setTimeout(function() {
                    window.location = '/upload-docs/update';
                }, 500);
            }

        }, 100);
    });

    $('.cancel').click(function(e) {
        e.preventDefault();
    });

    $(document).on('click', '.document-preview' , function(e) {
        e.preventDefault();

        var src = $(this).attr('href');
        var title = $(this).data('title');

        $.fancybox.open({
            type : 'html',
            src  : '<div class="document-preview-modal">' +
                '<h1>' + title + '</h1>' +
                '<img src="' + src + '" class="document-preview-image img-responsive">' +
                '</div>',
            opts: {
                touch: false
            }
        });
    });

    $(document).on('click', '.toggle-files', function(e) {
        e.preventDefault();

        $(this).parent().next('.files').toggleClass('hidden');
    });

    $(window).bind('beforeunload', function(e) {

        var count = 0;
        $(dropzones).each(function(key, dropzone) {
            count += dropzone.getQueuedFiles().length;
        });

        if( count )
        {
            return 'You have files selected that are pending upload. Did you mean to close the page?';
        }
    });

    //-----------------------------------
    // Facts
    //-----------------------------------
    if($('.facts').length) {
        window.setInterval(function() {

            var $out = $('.facts .item.active');

            var $in = $out.next();

            if (! $in.length) {
                $in = $('.facts .item:first');
            }

            $out.removeClass('active');
            $in.addClass('active');
        }, 5000);
    }

    //-----------------------------------
    // New checkout
    //-----------------------------------
    $(document).on('click', '.btn-find-address', function(e) {
        var postcode = $('.postcode').val();

        $.post('/checkout/postcode', { postcode: postcode }, function(response) {
            var results = response;

            var string = '<option value="">Select</option>';
            $.each(results, function(key, result) {
                string += '<option value="" data-town="' + result.posttown + '" data-county="' + result.county + '" data-addressline1="' + result.addressline1 + '" data-addressline2="' + result.addressline2 + '">' + result.summaryline + '</option>';
            });

            $('.results-select').html(string);
            $('.postcode-results').removeClass('hidden');
        });
    });

    $(document).on('click', '.postcode-cant-find a', function(e) {
        e.preventDefault();

        $('.address-fields').removeClass('hidden');
    });

    $(document).on('change', '.results-select', function(e) {
        var data = $(this).find('option:selected').data();

        $('.address-line-1').val(data.addressline1);
        $('.address-line-2').val(data.addressline2);
        $('.address-town').val(data.town);
        $('.address-county').val(data.county);

        $('.address-fields').removeClass('hidden');
    });

    if ($('.address-fields').length && $('.address-line-1').val() != "") {
        $('.address-fields').removeClass('hidden');
    }
});
